import React from "react";
import "../assets/css/studentdashboard.css";

const UnitCards = ({ maxUnits, registeredUnits, unusedUnits }) => {
  return (
    <div className="unit-cards">
      <div className="unit-card">Max Units: {maxUnits}</div>
      <div className="unit-card">Registered Units: {registeredUnits}</div>
      <div className="unit-card">Unused Units: {unusedUnits}</div>
    </div>
  );
};

export default UnitCards;
